<template>
  <div class="social-auth">
    <g-signin-button
      :params="googleSignInParams"
      @success="onSignInGoogleSuccess($event)"
      @error="log($event)">
      <GoogleIcon />
    </g-signin-button>
    <a class="social-link" :href="vkLink">
      <VKIcon />
    </a>
    <a class="yandex-link" :href="yandexLink">
      <YandexSocialIcon />
    </a>
    <a class="odnoklassniki-link" :href="okLink">
      <OdnoklassnikiIcon />
    </a>
  </div>
</template>

<script>
import axios from 'axios';
import { oauthApi, http, laravelHttp, refBookHttp, receptionHttp } from '@app/services';
import helper from '@app/services/helper';

import GoogleIcon from '@app/assets/social/google_color.svg?inline';
import VKIcon from '@app/assets/social/vk_color.svg?inline';
import OdnoklassnikiIcon from '@app/assets/social/odnoklassniki.svg?inline';
import YandexSocialIcon from '@app/assets/social-icons/yandex.svg?inline';


export default {
  components: {
    GoogleIcon, VKIcon, OdnoklassnikiIcon, YandexSocialIcon,
  },
  data: () => ({
    okLink: `https://connect.ok.ru/oauth/authorize?client_id=512000667489&scope=VALUABLE_ACCESS&response_type=token&redirect_uri=${window.location.origin}?redirect_url=${window.location.pathname}`,
    vkLink: `https://oauth.vk.com/authorize?client_id=7606335&display=page&redirect_uri=${window.location.origin + window.location.pathname}&scope=email&response_type=code&v=5.124`,
    instLink: `https://api.instagram.com/oauth/authorize?client_id=824347501663095&redirect_uri=${window.location.origin}/&scope=user_profile,user_media&response_type=code&state=${window.location.pathname}`,
    yandexLink: `https://oauth.yandex.ru/authorize?response_type=token&client_id=9aa642bb862c4bfb922d04096c3a17ae&redirect_uri=${window.location.origin}?redirect_url=${window.location.pathname}`,
    googleSignInParams: {
      client_id: '895949417832-d1o922c3thm4mhtjqq8dhk54d99jdoq6.apps.googleusercontent.com'
    },
  }),
  methods: {
    async onSignInGoogleSuccess(googleUser) {
      const oauthToken = Object.entries(googleUser).reduce((acc, [ key, value ]) => {
        if (!acc && value.access_token) {
          return value.access_token;
        }
        return acc;
      }, null);
      const redirectUrl = window.location.origin + window.location.pathname;
      const token = await oauthApi.getTokenByOAuthToken('google-oauth2', oauthToken, redirectUrl);
      this.$emit('success');
      await this.setToken(token);
    },
    async setToken(token) {
      // DOTO: Refactoring
      localStorage.setItem('auth_token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      http.setToken(token);
      laravelHttp.setToken(token);
      refBookHttp.setToken(token);
      receptionHttp.setToken(token);
      await helper.check();
      await this.$store.dispatch('permission/loadPermissions');
      await this.$store.dispatch('auth/setAuthStatus');
      await this.$store.dispatch('auth/setLastActivity');
    },
    log() {},
  }
};
</script>


<style scoped>
.social-auth {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
}
.yandex-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.yandex-link svg {
  height: 20px;
  width: 40px;
  margin-right: 2px;
}
.social-link {
  display: block;
  width: 40px;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.social-link svg {
  width: 40px;
}
.odnoklassniki-link {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff9801;
  width: 40px;
  border-radius: 50%;
  height: 40px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.odnoklassniki-link svg {
  color: #fff;
  width: 20px;
}
.blank-link {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  width: 40px;
  border-radius: 50%;
  height: 40px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.blank-link svg {
  width: 20px;
}
.g-signin-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.g-signin-button svg {
  width: 20px;
}
</style>